module.exports = __webpack_public_path__ + "img/214709.c5852092.png";